import { render, staticRenderFns } from "./Temporadas.vue?vue&type=template&id=10831cee"
import script from "./Temporadas.vue?vue&type=script&lang=js"
export * from "./Temporadas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports